import React, { forwardRef, type ComponentProps } from 'react';
import { Content } from '@radix-ui/react-dropdown-menu';
import { cn } from '@mentimeter/ragnar-tailwind-config';
import { menuContentDefaultClasses } from '../menuContentDefaultClasses';

export type DropdownMenuContentProps = ComponentProps<typeof Content>;

export const DropdownMenuContent = forwardRef<
  HTMLDivElement,
  DropdownMenuContentProps
>((props: DropdownMenuContentProps, forwardedRef) => {
  const { className, ...rest } = props;

  return (
    <Content
      ref={forwardedRef}
      loop
      collisionPadding={16}
      arrowPadding={4}
      sideOffset={1}
      className={cn(menuContentDefaultClasses, className)}
      {...rest}
    />
  );
});
